window.istouchdevice = false;
window.addEventListener('touchstart', function onFirstTouch() {
	window.istouchdevice = true;
	window.removeEventListener('touchstart', onFirstTouch, false);
}, false);

(function(window, $) {
	var overlay = $('body > .overlay');
	overlay.on('click', function() {
		$('.sidebar__menu__item.on').removeClass('on'); // hide sidebar content
		$('.wpml-ls-legacy-list-horizontal, .header__nav, .header__nav__item, .header__subnav__item, .tribe-mini-calendar-list-wrapper').removeClass('on'); // hide menu on tablet and mobile
		$(this).stop().removeClass('on');
		$(this).data('timeout', setTimeout(function () {
			overlay.appendTo('body').removeAttr('style');
		}, 400));

	});

	/* NAVIGATION */
	//desk
	function switchSubNav ( tab ) {
		var subnav = tab.parents('.header__subnav'),
			activeItem = tab,
			underliner = subnav.find('.underliner'),
			underlinerPosX = activeItem.position().left,
			underlinerPosY = activeItem.position().top + activeItem.outerHeight(),
			underlinerPosWidth = activeItem.outerWidth(),
			underlinerPosColor = activeItem.data('color');

		subnav.css('border-color', underlinerPosColor);
		underliner.css({
			'left': underlinerPosX,
			'top': underlinerPosY,
			'width': underlinerPosWidth,
			'background-color': underlinerPosColor
		});
	}

	$('.header__nav__item').on({
		mouseenter: function () {
			if ( window.innerWidth >= 1280 ) {
				var navItem = $(this),
					navItemFirstChild = navItem.find('.header__subnav__item:first-of-type');
				clearTimeout(navItem.data('timeout-off'));
				navItem.data('timeout-on', setTimeout(function () {
					navItem.addClass('on');
					navItemFirstChild.addClass('on');
					overlay.addClass('on');
					switchSubNav(navItemFirstChild);
				}, 100));
			}
		},
		mouseleave: function () {
			if ( window.innerWidth >= 1280 ) {
				var navItem = $(this);
				clearTimeout(navItem.data('timeout-on'));
				navItem.data('timeout-off', setTimeout(function () {
					navItem.removeClass('on');
					overlay.removeClass('on');
				}, 100));
			}
		}
	});
	$('.header__nav').on({ // background task
		mouseenter: function () {
			if ( window.innerWidth >= 1280 ) {
				clearTimeout($('.header, .pre-header').data('timeout'));
				$('.header, .pre-header').css({
					'position': 'relative',
					'z-index': 5500
				});
			}
		},
		mouseleave: function () {
			if ( window.innerWidth >= 1280 ) {
				$('.header, .pre-header').data('timeout', setTimeout(function () {
					$('.header, .pre-header').removeAttr('style');
				}, 200));
			}
		}
	});

	// sub navigation desk
	$('.header__subnav__item').on({
		mouseenter: function () {
			if ( window.innerWidth >= 1280 ) {
				var subNavItem = $(this),
					subNavItems = subNavItem.parent();
				clearTimeout(subNavItem.data('timeout-off'));
				subNavItem.data('timeout-on', setTimeout(function () {
					subNavItems.find('.header__subnav__item.on').removeClass('on');
					subNavItem.addClass('on');
					switchSubNav(subNavItem);
				}, 100));
			}
		},
		mouseleave: function () {
			if ( window.innerWidth >= 1280 ) {
				var subNavItem = $(this);
				clearTimeout(subNavItem.data('timeout-on'));
			}
		}
	});

	// tablet and mobile
	var goBackBtn = $('<button class="goBack">Retour</button>'),
		goBackBtnAdded = false,
		switchedToMob = false,
		navInserts = $('.header__subnav__item__content .inserts')[0];

	function switchToMob() {
		$(navInserts).clone().appendTo('.header__nav > ul');
		if ( !goBackBtnAdded ) {
			$('.header__subnav, .header__subnav__item__content, .header__nav__item__content--new .grid').each(function() {
				goBackBtn.clone().prependTo($(this));
			});
		}
		switchedToMob = true;
		goBackBtnAdded = true;
	}

	if ( window.innerWidth < 1280 ) switchToMob();
	$(window).on('resize', function() {
		if ( window.innerWidth < 1280 && !switchedToMob ) {
			switchToMob();
		} else if ( window.innerWidth >= 1280 && switchedToMob ) {
			$('.header__nav > ul').find('> .inserts').remove();
			switchedToMob = false;
		}
	});
	$('body').on('click', '.goBack', function() {
		$(this).closest('.on').removeClass('on');
	});

	$('.header__nav__burger').on('click', function() {
		overlay.prependTo('.sidebar').css({
			'position': 'fixed',
			'z-index': -1,
		});
		overlay.addClass('on');
		$('.wpml-ls-legacy-list-horizontal, .header__nav').addClass('on');
	});

	// sub navigation on tablet and mobile
	$('.header__nav__item__tab, .header__subnav__item__tab').on('click', function() {
		if ( window.innerWidth < 1280 ) {
			$(this).parent().addClass('on');
		}
	});

	// swipe to right on tablet and mobile to close menu
	var navLevel1 = [$('.wpml-ls-legacy-list-horizontal')[0], $('.header__nav > ul')[0]];
	for (var i = 0 ; i < navLevel1.length; i++) {
		var nl1h = new Hammer(navLevel1[i]);
		nl1h.on('swiperight', function(ev) {
			overlay.trigger('click');
		});
	}
	var navSubLevels = $('.header__subnav, .header__subnav__item__content, .header__nav__item__content--new .grid');
	for (var i = 0 ; i < navSubLevels.length; i++) {
		var nslh = new Hammer(navSubLevels[i]);
		nslh.on('swiperight', function(ev) {
			overlay.trigger('click');
		});
	}


	/* ASIDE MENU */
	$('.sidebar__menu__item__btn').on('click', function(e) {
		var item = $(this).parent();
		if ( item.find('.sidebar__menu__item__content').length > 0 ) {
			e.preventDefault();
			if ( !item.hasClass('on') ) $('.sidebar__menu__item.on').removeClass('on');
			if ( !$(this).hasClass('disable') ) {
				item.toggleClass('on');
				if ( window.innerWidth < 1280 ) {
					overlay.prependTo('.sidebar').css({
						'position': 'fixed',
						'z-index': -1,
					});
				}
				overlay.addClass('on');
			}
			if ( $('.sidebar__menu__item.on').length == 0 ) overlay.removeClass('on');
			if ( $('.tribe-mini-calendar-list-wrapper').hasClass('on') ) $('.tribe-mini-calendar-list-wrapper').removeClass('on');
		}
	});

	$('.sidebar').on('click', function(e) {
		if ( $(e.target).parents('.sidebar__menu__item').length == 0 ) {
			$('.sidebar__menu__item.on, .tribe-mini-calendar-list-wrapper').removeClass('on');
			overlay.removeClass('on');
		}
	});

	var sidebarContents = $('.sidebar__menu__item__content');
	for (var i = 0 ; i < sidebarContents.length; i++) {
		var sch = new Hammer(sidebarContents[i]);
		sch.on('swiperight', function(ev) {
			overlay.trigger('click');
		});
	}

	// close calendar widget on tablet and mobile
	$('.sidebar__menu__item__content--mini-calendar').on('click', '.tribe-mini-calendar-list-wrapper .close', function(e) {
		$('.tribe-mini-calendar-list-wrapper').removeClass('on');
	});

	/* QUICK ACCESS TO TOP MENU ON SCROLL TOP ON MOBILE DEVICE */
	var oldY = 0;
	window.addEventListener('scroll', function() {
		if ( window.innerWidth < 1280 ) {
			var y = window.scrollY || document.documentElement.scrollTop,
				headerNavOffsetTop = $('.header').offset().top + $('.header').outerHeight(),
				extraTop = 0;

			if ( $('.header').hasClass('fixed') && $('.header').hasClass('visible') ) {
				extraTop = $('.header').outerHeight() - 1;
			}

			if ( y >= (headerNavOffsetTop - extraTop) ) {
				if ( !$('.header').hasClass('fixed') ) {
					$('.header').addClass('fixed');
				}
			} else {
				$('.header.fixed').removeClass('fixed');
			}

			if ( y < oldY ) {
				if ( !$('.header').hasClass('visible') ) {
					$('.header').addClass('visible');
				}
			} else {
				$('.header.visible').removeClass('visible');
			}

			oldY = y;
		}
	});

	// slider pastilles rondes
	if ( $('.activites .flipboards-slider').length > 0 ) {
		$('.activites .flipboards-slider').slick({
	        infinite: true,
	        speed: 600,
	        slidesToShow: 3,
	        responsive: [
				{
	                breakpoint: 1024,
	                settings: {
	                    slidesToShow: 2
	                }
	            },
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1
					}
				}
	        ]
	    });
	}

	// slider temoignages
	if ( $('.temoignages__carousel').length > 0 ) {
		$('.temoignages__carousel').each(function() {
			var temoignagesSlider = $(this).find('.temoignages__carousel__items');
			temoignagesSlider.on('init', function(event, slick) {
				var totalSlides = temoignagesSlider.find('.slick-slide:not(.slick-cloned)').length;
				temoignagesSlider.parent().find('.paging .of').text(totalSlides);
			});
			temoignagesSlider.on('afterChange', function(event, slick, currentSlide, nextSlide) {
				temoignagesSlider.parent().find('.paging .index').text(currentSlide + 1);
			});
			if ( temoignagesSlider.find('.temoignages__carousel__item').length > 1 ) {
				temoignagesSlider.slick({
					infinite: true,
					fade: true,
					speed: 600,
					slidesToShow: 1,
					slidesToScroll: 1,
					appendArrows: '.temoignages__carousel__nav .arrows',
				});
			}
		});
	}

	// popin youtube
	if ( $('.popinYouTube').length > 0 ) {
		$('.popinYouTube').colorbox({
			iframe: true,
			width: 720,
			maxWidth: '80%',
			height: 405,
			maxHeight: '80%'
		});
	}
	
})(window, jQuery);
